import React, { useContext, useEffect, useState } from "react";
import moment from 'moment';
import { useMediaQuery } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button } from "@material-ui/core";
import { useNavigate } from "react-router";
import AuthContext from "../../../../hooks/authContext";
import SingleSelectNew from "../../../../components/SelectField/SingleSelectNew";

const NavBar = (props) => {
    const [mainCalDate, setMainCalDate] = useState(new Date());
    const [previousView, setPreviousView] = useState(null);
    const today = new Date()
    const isMobile = useMediaQuery("(max-width:767px)");
    const getCurrentWeek = (date) => {
        return moment(date).startOf('week').toDate();
    };
    const auth = useContext(AuthContext);
    const [currentWeek, setCurrentWeek] = useState(getCurrentWeek(today));
    const [selecteHandle, setSelecteHandle] = useState(null);
    let navigate = useNavigate();

    useEffect(() => {
        const startOfWeek = new Date(currentWeek);
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
        const datesArray = Array.from({ length: 7 }, (_, i) => {
            const nextDate = new Date(startOfWeek);
            nextDate.setDate(startOfWeek.getDate() + i);
            return nextDate;
        });
        props?.setWeekDates(datesArray);

        if (previousView === "month" && props?.view === "day") {
            props?.setSelectedDayDate(props?.currentDate)
        }
        props?.view === "month" && props?.setSelectedDayDate(currentWeek);

        const isDayToWeek = previousView === "day" && props?.view === "week";
        const isWeekToDay = previousView === "week" && props?.view === "day";
        const isWeekNavigation = selecteHandle === "weekPrevious" || selecteHandle === "weekNext";

        if ((isDayToWeek || isWeekToDay) && isWeekNavigation) {
            props?.setSelectedDayDate(datesArray[0]);
        } else {
            props?.setSelectedDayDate(props?.currentDate);
        }
    }, [currentWeek, mainCalDate, props?.view, previousView, selecteHandle])


    const formatDate = (date) => {
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long'
        }).format(date);
    };

    const previousMonth = () => {
        if (props?.view === "week") {
            setSelecteHandle("weekPrevious");
            setCurrentWeek((prevDate) => {
                const newDate = new Date(prevDate);
                newDate.setDate(newDate.getDate() - 7);
                return newDate;
            });
            setMainCalDate((prevDate) => {
                const newDate = new Date(prevDate);
                newDate.setDate(newDate.getDate() - 7);
                return newDate;
            });
            props?.setCurrentDate((prevDate) => {
                const newDate = new Date(prevDate);
                newDate.setDate(newDate.getDate() - 7);
                return newDate;
            })
        } else if (props?.view === "day") {
            setSelecteHandle("dayPrevious");
            const newSelectedDate = new Date(props?.selectedDayDate);
            newSelectedDate.setDate(newSelectedDate.getDate() - 1);

            props?.setSelectedDayDate(newSelectedDate);
            setCurrentWeek(newSelectedDate);
            props?.setCurrentDate(newSelectedDate);
            setMainCalDate((prevDate) => {
                const newDate = new Date(prevDate);
                newDate.setDate(newDate.getDate() + 1);
                return newDate;
            });
        } else {
            setSelecteHandle("monthPrevious");
            props?.setCurrentDate(new Date(props?.currentDate.getFullYear(), props?.currentDate.getMonth() - 1));
            setCurrentWeek(new Date(props?.currentDate.getFullYear(), props?.currentDate.getMonth() - 1));
            setMainCalDate(new Date(props?.currentDate.getFullYear(), props?.currentDate.getMonth() - 1))
        }
    };

    const nextMonth = () => {
        if (props?.view === "week") {
            setSelecteHandle("weekNext");
            setCurrentWeek((prevDate) => {
                const newDate = new Date(prevDate);
                newDate.setDate(newDate.getDate() + 7);
                return newDate;
            });
            setMainCalDate((prevDate) => {
                const newDate = new Date(prevDate);
                newDate.setDate(newDate.getDate() + 7);
                return newDate;
            });
            props?.setCurrentDate((prevDate) => {
                const newDate = new Date(prevDate);
                newDate.setDate(newDate.getDate() + 7);
                return newDate;
            })
        } else if (props?.view === "day") {
            setSelecteHandle("dayNext");
            const newSelectedDate = new Date(props?.selectedDayDate);
            newSelectedDate.setDate(newSelectedDate.getDate() + 1);

            props?.setSelectedDayDate(newSelectedDate);
            setCurrentWeek(newSelectedDate);
            props?.setCurrentDate(newSelectedDate);
            setMainCalDate((prevDate) => {
                const newDate = new Date(prevDate);
                newDate.setDate(newDate.getDate() + 1);
                return newDate;
            });
        } else {
            setSelecteHandle("monthNext");
            props?.setCurrentDate(new Date(props?.currentDate.getFullYear(), props?.currentDate.getMonth() + 1));
            setCurrentWeek(new Date(props?.currentDate.getFullYear(), props?.currentDate.getMonth() + 1));
            setMainCalDate(new Date(props?.currentDate.getFullYear(), props?.currentDate.getMonth() + 1))
        }
    };

    const getWeekRange = (dates) => {
        const startOfWeek = new Date(dates[0]);
        const endOfWeek = new Date(dates[dates.length - 1]);

        return `${moment(startOfWeek).format('MMM Do')} - ${moment(endOfWeek).format('MMM Do')}`;
    };

    const handelViewChange = (view) => {
        setPreviousView(props?.view);
        props?.setView(view);
    }

    const redirectToSchedule = () => {
        auth.setIsExpanded(false);
        navigate("/operations/appoinmentSchedule");
    };

    return (
        <div className="calendar-header">
            <div className="calendar-nav">
                <ArrowBackIosNewIcon className="arrowIcon dark:text-white" fontSize="small" onClick={previousMonth} />
                {props?.view === "month" &&
                    <h2 className="calendar-title dark:text-white">{formatDate(props?.currentDate)}</h2>
                }
                {props?.view === "week" &&
                    <h2 className="calendar-title dark:text-white">{getWeekRange(props?.weekDates)}</h2>
                }
                {props?.view === "day" &&
                    <h2 className="calendar-title dark:text-white">{moment(props?.selectedDayDate).isSame(moment(), 'day') ? 'Today' : moment(props?.selectedDayDate).format("DD MMM")}</h2>
                }
                <ArrowForwardIosIcon className="arrowIcon dark:text-white" fontSize="small" onClick={nextMonth} />
            </div>
            <div className='calendar-NavControl'>
                {/* {!isMobile ?
                    <div className="mr-20 calendarSelectWidth2">
                        <SingleSelect
                            value={props?.alerts}
                            name={"alerts"}
                            label={"Alerts"}
                            InputLabelProps={{ shrink: true }}
                            onChange={props?.handleAlertChange}
                            options={props?.allAlerts}
                            datetime={true}
                        />
                    </div> : null} */}
                {auth?.userProfile?.role !== "Client" && (
                !isMobile ?
                    <div className="mr-20 calendarSelectWidth">
                        <SingleSelectNew
                            value={props?.clientName}
                            name={"clientName"}
                            label={"Client Name"}
                            contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                            itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                            onChange={props?.handelClientNameChange}
                            options={props?.clientNameList}
                            datetime={true}
                        />
                    </div> : null
                )}
                {!isMobile ?
                    <div className="mr-20 calendarSelectWidth">
                        <SingleSelectNew
                            value={props?.empNames}
                            name={"employeeName"}
                            label={"Employee Name"}
                            onChange={props?.handleEmpNameChange}
                            options={props?.employeeNameList}
                            datetime={true}
                            inactive={true}
                            contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                            itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                            allEmployees={props?.allEmployees}
                        />
                    </div> : null}
                <div className="calendar-controls">
                    <div className="view-toggle">
                        <Button
                            onClick={() => handelViewChange('day')}
                            variant='outlined'
                            className={`navButtons view-toggle-btn ${props?.view === 'day' ? 'active' : 'dark:text-white'}`}
                        >
                            Day
                        </Button>
                        <Button
                            onClick={() => handelViewChange('week')}
                            variant='outlined'
                            className={`navButtons view-toggle-btn ${props?.view === 'week' ? 'active' : 'dark:text-white'}`}
                        >
                            Week
                        </Button>
                        <Button
                            onClick={() => handelViewChange('month')}
                            variant='outlined'
                            className={`navButtons view-toggle-btn ${props?.view === 'month' ? 'active' : 'dark:text-white'}`}
                        >
                            Monthly
                        </Button>
                    </div>
                </div>
                {/* {!isMobile ?
                    <div className="ml-20">
                        <Button
                            variant="contained"
                            className="pv-7 ph-16"
                            style={{ backgroundColor: "#16A34A", color: "white" }}
                            onClick={redirectToSchedule}
                        >
                            Schedule Now
                        </Button>
                    </div>
                    : null} */}
            </div>
        </div>
    )
}

export default NavBar;